import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Fieldset } from "primereact/fieldset";
import {Card} from "primereact/card";
import {Divider} from "primereact/divider";

const CreditAndPolicyForm = ({ formData, handleInputChange, parseDate, handleDateChange, tienePermiso }) => {

    const insurance = [
        { code: 1, name: 'QUALITAS' },
        { code: 2, name: 'ING' },
        { code: 3, name: 'GENERAL' },
        { code: 4, name: 'AXA' },
        { code: 5, name: 'ABA' },
        { code: 6, name: 'HDI' },
    ];

    const nameUnit = [
        { code: 1, name: 'EDUARDO PADILLA' },
        { code: 2, name: 'UDITH ORTIZ' },
        { code: 3, name: 'TPS EMPRESARIAL' },
    ];

    const legendTemplate = (
        <div className="flex align-items-center justify-content-between w-full">
            <div>
                <h3 className="m-0 text-lg font-semibold text-color">Datos de Crédito y Póliza</h3>
                <p className="m-0 mt-1 text-sm text-color-secondary">Sistema de Gestión Vehicular</p>
            </div>
        </div>
    );

    return (
        <Fieldset legend={legendTemplate} toggleable className="mb-3 mt-3">
            <Card className="shadow-2" style={{ background: '#F4F6F9' }}>

                <div className="p-fluid">
                    {/* Información del Crédito */}
                    <div className="mb-2">
                        <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                            <i className="pi pi-dollar text-primary"></i>
                            <h3 className="m-0 text-lg font-semibold text-900">Información del Crédito</h3>
                        </div>
                        <div className="formgrid grid">
                            <div className="col-12 md:col-3">
                                <label htmlFor="nombreUnidad" className="block mb-1 text-sm font-medium text-700">Nombre Unidad</label>
                                <Dropdown
                                    id="nombreUnidad"
                                    value={nameUnit?.find(name => name.code === formData?.NOMBRE)}
                                    options={nameUnit}
                                    optionLabel="name"
                                    onChange={(e) => handleInputChange('NOMBRE', e.value.code)}
                                    className="w-full"
                                    placeholder="Seleccione..."
                                    disabled={!tienePermiso}
                                />
                            </div>

                            <div className="col-12 md:col-3">
                                <label htmlFor="valorUnidad" className="block mb-1 text-sm font-medium text-700">Valor Unidad</label>
                                <InputNumber
                                    id="valorUnidad"
                                    value={formData?.VALOR_UNIDAD}
                                    onValueChange={(e) => handleInputChange('VALOR_UNIDAD', e.value)}
                                    mode="currency"
                                    currency="USD"
                                    locale="en-US"
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>

                            <div className="col-12 md:col-2">
                                <label htmlFor="plazo" className="block mb-1 text-sm font-medium text-700">Plazo en meses</label>
                                <InputNumber
                                    id="plazo"
                                    value={formData?.PLAZO}
                                    onValueChange={(e) => handleInputChange('PLAZO', e.value)}
                                    className="w-full"
                                    maxLength={2}
                                    placeholder="Ej: 48"
                                    disabled={!tienePermiso}
                                />
                            </div>

                            <div className="col-12 md:col-2">
                                <label htmlFor="inicioCredito" className="block mb-1 text-sm font-medium text-700">Inicio Crédito</label>
                                <Calendar
                                    id="inicioCredito"
                                    value={parseDate(formData?.INICIO_CREDITO)}
                                    onChange={handleDateChange('INICIO_CREDITO')}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    locale="es"
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>

                            <div className="col-12 md:col-2">
                                <label htmlFor="finCredito" className="block mb-1 text-sm font-medium text-700">Fin Crédito</label>
                                <Calendar
                                    id="finCredito"
                                    value={parseDate(formData?.FIN_CREDITO)}
                                    onChange={handleDateChange('FIN_CREDITO')}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    locale="es"
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>
                        </div>
                    </div>

                    <Divider />

                    {/* Información de la Póliza */}
                    <div className="mb-2">
                        <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                            <i className="pi pi-shield text-primary"></i>
                            <h3 className="m-0 text-lg font-semibold text-900">Información de la Póliza</h3>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-2">
                                <label htmlFor="aseguradora" className="block">Aseguradora</label>
                                <Dropdown
                                    id="aseguradora"
                                    value={insurance?.find(ins => ins.code === formData?.ASEGURADORA)}
                                    options={insurance}
                                    optionLabel="name"
                                    onChange={(e) => handleInputChange('ASEGURADORA', e.value.code)}
                                    className="w-full"
                                    placeholder="Seleccione..."
                                    disabled={!tienePermiso}
                                />
                            </div>

                            <div className="field col-12 md:col-3">
                                <label htmlFor="polizaNumero" className="block">N° Póliza</label>
                                <InputText
                                    id="polizaNumero"
                                    value={formData?.POLIZA_NUMERO}
                                    onChange={(e) => handleInputChange('POLIZA_NUMERO', e.target.value)}
                                    className="w-full"
                                    maxLength={50}
                                    placeholder="Número de póliza"
                                    disabled={!tienePermiso}
                                />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="vigenciaPoliza" className="block">Vigencia Póliza</label>
                                <Calendar
                                    id="vigenciaPoliza"
                                    value={parseDate(formData?.POLIZA_VIGENCIA)}
                                    onChange={handleDateChange('POLIZA_VIGENCIA')}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    locale="es"
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="costoNeto" className="block">Costo Neto</label>
                                <InputNumber
                                    id="costoNeto"
                                    value={formData?.POLIZA_COSTO}
                                    onValueChange={(e) => handleInputChange('POLIZA_COSTO', e.value)}
                                    mode="currency"
                                    currency="USD"
                                    locale="en-US"
                                    className="w-full"
                                    disabled={!tienePermiso}
                                />
                            </div>

                            <div className="field col-12 md:col-3">
                                <label htmlFor="telSiniestros" className="block">Tel. Siniestros</label>
                                <InputText
                                    id="telSiniestros"
                                    value={formData?.POLIZA_TEL_SINIESTROS}
                                    onChange={(e) => handleInputChange('POLIZA_TEL_SINIESTROS', e.target.value)}
                                    maxLength={10}
                                    className="w-full"
                                    placeholder="Teléfono de emergencia"
                                    keyfilter="num"
                                    disabled={!tienePermiso}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </Card>
        </Fieldset>
    );
};

export default CreditAndPolicyForm;
